<!--
 * @Author: your name
 * @Date: 2021-07-09 14:22:41
 * @LastEditTime: 2022-04-12 17:37:15
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vindel-map-pc\src\App.vue
-->
<template>
    <div class="exam">        
        <div class="exam-header">            
            <div class="header-detail">
                <img class="header-bg" src="../../assets/exam/Breadcrumb.png" alt="">
                <div class="paper-headr">
                    <div class="exam-center">考试中心</div>
                    <div style="display:flex;">
                        <div class="paper-name">{{ detail.paperDetail.paperName }} {{ detail.exam.examDoModeCode == 'paper' ? '整卷模式' : '逐题模式' }}{{ `[${detail.exam.examName}]` }}</div>
                        <div v-if="canSeeGrade" style="margin-left:16px;position: relative;width: 120px;height: 48px;display: flex;justify-content: center;align-items: end;">
                            <img  class="header-bg" src="../../assets/exam/score.png" alt="">
                            <span style="font-size: 38px;padding-left: 5px;z-index:9; font-family: DINPro, DINPro-Medium;font-weight: 500;text-align: left;color: #ffffff;line-height: 49px">{{detail.examGrade.gradeScore ? detail.examGrade.gradeScore : 0}}</span>
                            <span style="z-index:9;line-height: 2;color: #ffffff;">分</span>
                        </div>
                    </div>
                    <div class="paper-message"> 
                        <span style="margin-right:18px;"><span class="label">共:</span> {{ `${detail.paperDetail.examPaper.questionNum}题` }} </span>
                        <span style="margin-right:18px;"><span class="label">满分:</span> {{ `${detail.paperDetail.examPaper.totalScore}分` }} </span>
                        <span ><span class="label">总时长:</span> {{examTime ? `${examTime}分钟`: '不限时'}}</span>
                    </div>
                </div>
            </div>
            <div class="headers-nav">
                <div class="user-detail"  v-if="detail.userInfo">
                    <img v-if="imgUrl" :src="imgUrl" alt="">
                    <img
                      v-else-if="detail.userInfo.sex == 'female'"
                      class="userInfo-img"
                      src="../../assets/female.png"
                      alt=""
                    />
                    <img
                      v-else
                      class="userInfo-img"
                      src="../../assets/male.png"
                      alt=""
                    />
                    <div class="user-right">
                        <div class="user-name" v-if="detail.userInfo">{{detail.userInfo.userName}}({{detail.userInfo.name}})</div>
                        <div class="user-code" v-if="detail.userInfo">编号:{{detail.userInfo.userCode}}</div>
                    </div>
                </div>
                <div class="nav-right">
                    <div class="operate-btn" v-if="!isStop">                       
                        <div class="exam-btn"  @click="closePaper">
                            <img src="../../assets/close.png" alt="">
                            <span>关闭试卷</span>
                        </div>                      
                    </div>
                </div>
            </div>
        </div>     
        <div class="exam-main">
            <el-row style="height: 100%">
                <el-col style="height: 100%;" :span="16">
                    <div class="main-left" :class="[isStop && 'disable']">                            
                            <div class="paper-detail" v-for="(item, index) in detail.paperDetail.paperNodes" :key="index">
                                <div class="node-head">{{ sortList[index] }}、{{ item.examPaperNode.paperNodeName }} <span class="tips">({{ item.examPaperNode.questionNum }}题,共{{ item.examPaperNode.questionScore }}分)</span></div>
                                <div class="node-content">
                                    <div class="node-question" :id="subItem.id" v-for="(subItem, subIndex) in item.questions" :key="`${subItem.id}${subIndex}`">
                                        <div class="node-question-title">
                                            {{ subIndex + 1 }}.
                                            <span class="question-content" v-if="subItem.questionText" v-html="subItem.questionText"></span>
                                            <span class="tips">({{ subItem.score }}分)</span>
                                            <span class="node-qusetion-typeName">{{ subItem.questionTypeName }}</span>                                         
                                        </div>
                                        <template v-if="subItem.questionBaseTypeCode == 'compose'">
                                             <div class="node-question" style="padding-left:16px;" :id="childItem.id" v-for="(childItem, childIndex) in subItem.childQuestions" :key="childIndex">
                                                <div class="node-question-title">
                                                         ({{ childIndex + 1 }})
                                                    <span class="question-content" v-if="childItem.questionText" v-html="childItem.questionText"></span>
                                                    <span class="tips">({{ childItem.score }}分)</span>
                                                    <span class="node-qusetion-typeName">{{ childItem.questionTypeName }}</span>                                                 
                                                </div>
                                                <template v-if="childItem.selectAnswers.length > 1 && childItem.questionBaseTypeCode == 'single'">
                                                    <el-radio-group disabled v-model="childItem.answerText" style="width: 100%">
                                                        <div class="node-question-content" v-for="(item, index) in childItem.selectAnswers" :key="`${childItem.id}${index}`">
                                                            <el-radio :label="selectType[index]"
                                                                ><span style="margin-right: 8px">{{ selectType[index] }}.</span>
                                                                <div style="display: inline-block;max-width: 785px;line-height: 20px;word-break: break-all;white-space: pre-wrap;" v-html="item"></div
                                                            ></el-radio>
                                                        </div>
                                                    </el-radio-group>
                                                </template>
                                                <template v-if="childItem.questionBaseTypeCode == 'judge'">
                                                    <el-radio-group disabled v-model="childItem.answerText" style="width: 100%">
                                                        <div class="node-question-content">
                                                            <el-radio  label="Y">正确</el-radio>
                                                            <el-radio  label="N">错误</el-radio>
                                                        </div>
                                                    </el-radio-group>
                                                </template>                                       
                                                <template v-if="childItem.questionBaseTypeCode == 'fill'">                                              
                                                    <div class="node-question-answers" style="display:flex;align-items: flex-end;">
                                                        <div style="display:flex;" v-for="(item, index) in childItem.answerText" :key="`${childItem.id}${index}`">                                                            
                                                            <div style="display:flex;background-color:#f5f7fa;width: 176px;height: 28px;border: 1px solid #999999;border-radius: 2px;font-size: 12px;align-items: center;padding-left: 5px;font-weight: 400;" class="exam-input" >                                                        
                                                                {{item}}
                                                            </div> 
                                                            <div style="display: flex;align-items: end;" v-if="index != childItem.standardAnswerCount - 1">
                                                                、
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>                                   
                                                <template v-if="childItem.questionBaseTypeCode == 'judge_correct'">                                            
                                                    <div class="node-question-answers">                                        
                                                        <el-radio-group disabled style="width: 100%"  v-model="childItem.judge_correctLabel">
                                                            <div class="node-question-content" style="display: inline-flex; border: none">
                                                                <el-radio label="Y">正确</el-radio>
                                                                <el-radio label="N">错误</el-radio>
                                                                <input class="exam-input" disabled style=" width: 176px;height: 28px;border: 1px solid #999999;border-radius: 2px;" v-if="childItem.judge_correctLabel == 'N'" v-model="childItem.answerText" ></input>
                                                            </div> 
                                                        </el-radio-group>
                                                    </div>
                                                </template>
                                                <template v-if="childItem.questionBaseTypeCode == 'answer'">
                                                    <div class="node-question-answers">
                                                        <el-input disabled type="textarea" class="exam-input" v-model="childItem.answerText" name="" id="" cols="30" rows="1"></el-input>
                                                    </div>
                                                </template>
                                                <template v-if="childItem.selectAnswers.length > 1 && childItem.questionBaseTypeCode == 'multi'">                                                   
                                                    <el-checkbox-group disabled v-model="childItem.answerText" style="width: 100%">
                                                        <div class="node-question-content" v-for="(item, index) in childItem.selectAnswers" :key="`${childItem.id}${index}`">
                                                            <el-checkbox    :label="selectType[index]"
                                                                ><span style="margin-right: 8px">{{ selectType[index] }}</span>
                                                                <div style="display: inline-block;max-width: 785px;line-height: 20px;word-break: break-all;white-space: pre-wrap;" v-html="item"></div
                                                            ></el-checkbox>
                                                        </div>
                                                    </el-checkbox-group>                                                                                             
                                                </template>
                                                <div class="answer-modal" >                                          
                                                   <div    class="modal-item"   v-if="isAllowSeeAnswer" >                                                                                       
                                                          <!-- 是否允许查看标准答案 -->
                                                          <div class="item-left" style="color:#bbbbbb;display: inline-block" >标准答案:</div>
                                                            <div  class="item-right" style="display: inline-block;" v-if="subItem.questionBaseTypeCode == 'judge_correct'" >
                                                                <span v-if="childItem.standardAnswers.length == 0">N</span>
                                                                <span v-else-if="childItem.standardAnswers[0] == 'Y'">Y</span>
                                                                <span v-else>{{childItem.standardAnswers.join(' | ')}} </span> 
                                                            </div>                                                
                                                            <div class="item-right" style="display: inline-block;" v-else-if="childItem.standardAnswers.length > 1" >                                                        
                                                              <span>{{childItem.standardAnswers.join('|')}}</span>
                                                            </div>
                                                            <div class="item-right" style="display: inline-block;" v-else v-html="childItem.standardAnswers[0]">                                                        
                                                            </div>
                                                    </div>
                                                    <div style="display:flex;margin-bottom:5px" >
                                                        <div  class="modal-item" >
                                                            <div  class="item-left" style="color:#bbbbbb">考生答案:</div>
                                                            <div  class="sad item-right" :class="[childItem.judgeResultCode == 'right' && 'green', childItem.judgeResultCode != 'right' && 'red']" v-if="childItem.questionBaseTypeCode == 'judge_correct'" >
                                                                <span v-if="childItem.answerText == 'Y'">Y</span>
                                                                <span v-else-if="childItem.answerText == 'N'">N</span> 
                                                                <span v-else><span  :class="[(childItem.judgeResultCode == 'right' || childItem.judgeResultCode == 'middle' ) && 'green', childItem.judgeResultCode == 'error' && 'red']">{{childItem.answerText ? childItem.answerText.split('$contentsplit$')[0]:'-' }}</span><span v-if="childItem.answerText" style="color:#000 !important;"> | </span><span :class="[childItem.judgeResultCode == 'right' && 'green']">{{childItem.answerText ? childItem.answerText.split('$contentsplit$')[1]:'-' }}</span></span>
                                                            </div>
                                                            <div  class="sad item-right"  v-else-if="childItem.questionBaseTypeCode == 'multi'"  :class="[childItem.judgeResultCode == 'right' && 'green', childItem.judgeResultCode != 'right' && 'red']">
                                                              <span v-for="(mItem,mIndex) in childItem.answerList" :class="[mItem.code == 'right' && 'green', mItem.code != 'right' && 'red']"  :key="mIndex">
                                                                  {{mItem.value}} <span style="color:#000 !important;" v-if="mIndex +1 != childItem.answerList.length">|</span>
                                                              </span>
                                                            </div>
                                                            <div   class="sad item-right"  v-else-if="childItem.questionBaseTypeCode == 'fill'"  :class="[childItem.judgeResultCode == 'right' && 'green', childItem.judgeResultCode != 'right' && 'red']">
                                                              <span v-for="(mItem,mIndex) in childItem.answerList" :class="[mItem.code == 'right' && 'green', mItem.code != 'right' && 'red']"  :key="mIndex">
                                                                  {{mItem.value}} <span style="color:#000 !important;" v-if="mIndex +1 != childItem.answerList.length">|</span>
                                                              </span>
                                                            </div>
                                                            <div class="sad item-right" ref="asdsad"  v-else  :class="[childItem.judgeResultCode == 'right' && 'green', childItem.judgeResultCode != 'right' && 'red']" v-html="childItem.answerText ? childItem.answerText : '-'"> </div>                                                                                         
                                                            <div id="myModal" class="modal">
                                                                <span class="close">×</span>
                                                                <img class="modal-content" id="img01"/>
                                                                <div id="caption"></div>
                                                            </div> 
                                                        </div>                                           
                                                    </div>                                      
                                                    <div class="modal-item">
                                                      <div class="item-left">答题时间:</div>
                                                      <div class="item-right"> {{childItem.answerTime ? childItem.answerTime + '秒' : '-' }}</div>                                                    
                                                    </div>
                                                    <div style="display:flex;">
                                                        <div class="modal-item" v-if="canSeeGrade">
                                                            <div class="item-left" style="color:#bbbbbb">考生得分:</div>
                                                            <div class="item-right" style="margin-left:5px">
                                                               <span  class="green" v-if="childItem.judgeScore > 0">{{childItem.judgeScore}}分</span>
                                                            <span class="red" v-else>{{childItem.judgeScore}}分</span>    
                                                                                                      
                                                            </div>
                                                        </div>
                                                        <div class="modal-item">
                                                            <div class="item-left" style="color:#bbbbbb">老师评语:</div>
                                                            <div class="item-right">{{childItem.judgeRemarks ? childItem.judgeRemarks :'-'}}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                        <template v-if="subItem.selectAnswers.length > 1 && subItem.questionBaseTypeCode == 'single'">
                                            <el-radio-group disabled v-model="subItem.answerText" style="width: 100%">
                                                <div class="node-question-content" v-for="(item, index) in subItem.selectAnswers" :key="`${subItem.id}${index}`">
                                                    <el-radio :label="selectType[index]"
                                                        ><span style="margin-right: 8px">{{ selectType[index] }}.</span>
                                                        <div style="display: inline-block;max-width: 785px;line-height: 20px;word-break: break-all;white-space: pre-wrap;" v-html="item"></div
                                                    ></el-radio>
                                                </div>
                                            </el-radio-group>
                                        </template>
                                        <template v-if="subItem.questionBaseTypeCode == 'judge'">
                                            <el-radio-group disabled v-model="subItem.answerText" style="width: 100%">
                                                <div class="node-question-content">
                                                    <el-radio  label="Y">正确</el-radio>
                                                    <el-radio  label="N">错误</el-radio>
                                                </div>
                                            </el-radio-group>
                                        </template>                                       
                                        <template v-if="subItem.questionBaseTypeCode == 'fill'">
                                            <div class="node-question-answers" style="display:flex;align-items: flex-end;">
                                                <div style="display:flex;" v-for="(item, index) in subItem.answerText" :key="`${subItem.id}${index}`">
                                                    <div style="display:flex;" class="exam-input">                                                        
                                                        {{item}}
                                                    </div> 
                                                    <div style="display: flex;align-items: end;" v-if="index != subItem.standardAnswerCount - 1">
                                                        、
                                                    </div>
                                                </div>
                                            </div>
                                        </template>                                   
                                        <template v-if="subItem.questionBaseTypeCode == 'judge_correct'">
                                            <div class="node-question-answers">                                        
                                                <el-radio-group disabled style="width: 100%"  v-model="subItem.judge_correctLabel">
                                                    <div class="node-question-content" style="display: inline-flex; border: none">
                                                        <el-radio label="Y">正确</el-radio>
                                                        <el-radio label="N">错误</el-radio>
                                                        <input class="exam-input" disabled style=" width: 176px;height: 28px;border: 1px solid #999999;border-radius: 2px;" v-if="subItem.judge_correctLabel == 'N'" v-model="subItem.answerText.split('$contentsplit$')[1]"/>
                                                    </div> 
                                                </el-radio-group>
                                            </div>
                                        </template>
                           
                                        <template v-if="subItem.selectAnswers.length > 1 && subItem.questionBaseTypeCode == 'multi'">
                                            <el-checkbox-group disabled v-model="subItem.answerText" style="width: 100%">
                                                <div class="node-question-content" v-for="(item, index) in subItem.selectAnswers" :key="`${subItem.id}${index}`">
                                                    <el-checkbox    :label="selectType[index]"
                                                        ><span style="margin-right: 8px">{{ selectType[index] }}</span>
                                                        <div  style="display: inline-block;max-width: 785px;line-height: 20px;word-break: break-all;white-space: pre-wrap;" v-html="item"></div
                                                    ></el-checkbox>
                                                </div>
                                            </el-checkbox-group>                                            
                                        </template>
                                        <div class="answer-modal" style="margin-bottom:16px;" v-if="subItem.questionBaseTypeCode != 'compose' && subItem.questionBaseTypeCode == 'answer' && isAllowSeeAnswer">
                                             <div   v-if="isAllowSeeAnswer">
                                                  <div class="item-left" style="color:#bbbbbb;" >标准答案:</div>
                                                    <div  class="item-right" style="display: inline-block;" v-if="subItem.questionBaseTypeCode == 'judge_correct'" >
                                                        <span v-if="subItem.standardAnswers.length == 0">N</span>
                                                        <span v-else-if="subItem.standardAnswers[0] == 'Y'">Y</span>
                                                        <span v-else>{{subItem.standardAnswers.join(' | ')}} </span> 
                                                    </div>                                                
                                                    <div class="item-right" style="display: inline-block;" v-else-if="subItem.standardAnswers.length > 1" >                                                        
                                                      <span>{{subItem.standardAnswers.join('|')}}</span>
                                                    </div>
                                                    <div class="item-right" style="display: inline-block;" v-else v-html="subItem.standardAnswers[0]">                                                        
                                                    </div>
                                                </div>             
                                        </div>
                                        <div class="answer-modal" v-if="subItem.questionBaseTypeCode != 'compose'">                                          
                                           <div    class="modal-item"  v-if="subItem.questionBaseTypeCode != 'compose' && subItem.questionBaseTypeCode != 'answer' && isAllowSeeAnswer ">                                                                                       
                                                  <div class="item-left" style="color:#bbbbbb;display: inline-block" >标准答案:</div>
                                                    <div  class="item-right" style="display: inline-block;" v-if="subItem.questionBaseTypeCode == 'judge_correct'" >
                                                        <span v-if="subItem.standardAnswers.length == 0">N</span>
                                                        <span v-else-if="subItem.standardAnswers[0] == 'Y'">Y</span>
                                                        <span v-else>{{subItem.standardAnswers.join(' | ')}} </span> 
                                                    </div>                                                
                                                    <div class="item-right" style="display: inline-block;" v-else-if="subItem.standardAnswers.length > 1" >                                                        
                                                      <span>{{subItem.standardAnswers.join('|')}}</span>
                                                    </div>
                                                    <div class="item-right" style="display: inline-block;" v-else v-html="subItem.standardAnswers[0]">                                                        
                                                    </div>
                                            </div>
                                            <div style="margin-bottom:5px" >
                                                <div  class="modal-item" >
                                                    <div  class="item-left" style="color:#bbbbbb;    display: block;margin-bottom:5px">考生答案:</div>
                                                      <!-- <button  @click="AApreviewVisible">21321</button> -->
                                                    <div  class="sad item-right" :class="[subItem.judgeResultCode == 'right' && 'green', subItem.judgeResultCode != 'right' && 'red']" v-if="subItem.questionBaseTypeCode == 'judge_correct'" >
                                                        <span v-if="subItem.answerText == 'Y'">Y</span>
                                                        <span v-else-if="subItem.answerText == 'N'">N</span> 
                                                        <span v-else><span  :class="[(subItem.judgeResultCode == 'right' || subItem.judgeResultCode == 'middle' ) && 'green', subItem.judgeResultCode == 'error' && 'red']">{{subItem.answerText ? subItem.answerText.split('$contentsplit$')[0]:'-' }}</span><span v-if="subItem.answerText" style="color:#000 !important;"> | </span><span :class="[subItem.judgeResultCode == 'right' && 'green']">{{subItem.answerText ? subItem.answerText.split('$contentsplit$')[1]:'-' }}</span></span>
                                                    </div>
                                                    <div  class="sad item-right"  v-else-if="subItem.questionBaseTypeCode == 'multi'"  :class="[subItem.judgeResultCode == 'right' && 'green', subItem.judgeResultCode != 'right' && 'red']">
                                                      <span v-for="(mItem,mIndex) in subItem.answerList" :class="[mItem.code == 'right' && 'green', mItem.code != 'right' && 'red']"  :key="mIndex">
                                                          {{mItem.value}} <span style="color:#000 !important;" v-if="mIndex +1 != subItem.answerList.length">|</span>
                                                      </span>
                                                    </div>
                                                    <div   class="sad item-right"  v-else-if="subItem.questionBaseTypeCode == 'fill'"  :class="[subItem.judgeResultCode == 'right' && 'green', subItem.judgeResultCode != 'right' && 'red']">
                                                      <span v-for="(mItem,mIndex) in subItem.answerList" :class="[mItem.code == 'right' && 'green', mItem.code != 'right' && 'red']"  :key="mIndex">
                                                          {{mItem.value}} <span style="color:#000 !important;" v-if="mIndex +1 != subItem.answerList.length">|</span>
                                                      </span>
                                                    </div>
                                                    <div class="sad item-right" ref="asdsad"  v-else  :class="[subItem.judgeResultCode == 'right' && 'green', subItem.judgeResultCode != 'right' && 'red']" v-html="subItem.answerText ? subItem.answerText : '-'"> </div>                                                                                         
                                                <!--The modal-->
                                                <div id="myModal" class="modal">
                                                    <span class="close">×</span>
                                                    <img class="modal-content" id="img01"/>
                                                    <div id="caption"></div>
                                                </div> 
                                              </div>                                           
                                            </div>
                                            <div class="modal-item">
                                              <div class="item-left">答题时间:</div>
                                              <div class="item-right"> {{subItem.answerTime ? subItem.answerTime + '秒' : '-' }}</div>                                                    
                                            </div>
                                            <div style="display:flex;">
                                                <div class="modal-item" v-if="canSeeGrade">
                                                    <div class="item-left" style="color:#bbbbbb">考生得分:</div>
                                                    <div class="item-right" style="margin-left:5px">
                                                        <span  class="green" v-if="subItem.judgeScore > 0">{{subItem.judgeScore}}分</span>
                                                            <span class="red" v-else>{{subItem.judgeScore}}分</span>                                                    
                                                    </div>
                                                </div>
                                                <div class="modal-item">
                                                    <div class="item-left" style="color:#bbbbbb">老师评语:</div>
                                                    <div class="item-right">{{subItem.judgeRemarks ? subItem.judgeRemarks :'-'}}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>
                </el-col>
                <el-col style="height: 100%" :span="6">
                    <div class="main-right">                      
                        <div class="answers-card">
                            <div class="card-head">
                                考试信息
                            </div>
                            <div class="card-main">
                                <div class="card-item">
                                    <span class="item-left">考试编号:</span>
                                    <span class="item-right">{{detail.exam.examCode}}</span>
                                </div>                                
                                <div class="card-item">
                                    <span class="item-left">考生姓名:</span>
                                    <span class="item-right">{{detail.userInfo.userName}}</span>                                    
                                </div>                                
                                <div class="card-item">
                                    <span class="item-left">答题时间:</span>
                                    <span class="item-right">{{ detail.examGrade.beginTimeValue ? `${detail.examGrade.beginTimeValue.split(':')[0]}:${detail.examGrade.beginTimeValue.split(':')[1]}` : '-' }} 至 {{detail.examGrade.endTimeValue ? `${detail.examGrade.endTimeValue.split(':')[0]}:${detail.examGrade.endTimeValue.split(':')[1]}` : '-'}}</span>
                                </div>                                
                                <div class="card-item">
                                    <span class="item-left">答题耗时:</span>
                                    <van-count-down  class="item-right" ref="countDown" :auto-start="false" :time="detail.examGrade.examTime * 1000"  format="DD 天 HH 时 mm 分 ss 秒" >
                                        <template #default="timeData">
                                          <span class="block">{{ timeData.hours < 10 ? '0' + timeData.hours :timeData.hours  }}</span>
                                          <span class="block">:</span>
                                          <span class="block">{{ timeData.minutes < 10 ? '0' + timeData.minutes :timeData.minutes  }}</span>
                                          <span class="block">:</span>
                                          <span class="block">{{ timeData.seconds < 10 ? '0' + timeData.seconds :timeData.seconds  }}</span>
                                        </template>
                                    </van-count-down>
                                    <!-- <span class="item-right">{{detail.examGrade.examTime}}</span> -->
                                </div>                                
                                <div class="card-item">
                                    <span class="item-left">评卷人员:</span>
                                    <span class="item-right">{{detail.examGrade.judgeUserName ? detail.examGrade.judgeUserName : '系统自动评卷'}}</span>
                                </div>                                
                                <div class="card-item" v-if="detail.examGrade.judgeBeginTime && detail.examGrade.judgeEndTime">
                                    <span class="item-left">评卷时间:</span>
                                    <span class="item-right">{{moment(detail.examGrade.judgeBeginTime, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm")}} 至 {{moment(detail.examGrade.judgeEndTime, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm") }}</span>
                                </div>                                                                                       
                                <div class="card-item"  v-if="canSeeGrade">
                                    <span class="item-left">考试得分:</span>
                                    <span class="item-right">{{detail.examGrade.gradeScore ? detail.examGrade.gradeScore : 0}}分</span>
                                </div>                                                                                       
                            </div>
                                                                                                 
                        </div>                       
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import Api from "@/api/paper";
import axios from "axios";
import moment from "moment";

export default {
  data() {
    return {
      dialogVisible: false,
      isSignNum: 0,
      examUid: "",
      judge_correctLabel: "Y",
      examArrangeUid: "",
      gradeScore: "",
      answerDialogVisible: false,
      examTime: 0,
      detail: {
        paperDetail: {
          examPaper: {
            questionNum: "-",
            totalScore: "-",
          },
        },
        examGrade: {},
        exam: {
          examTime: "-",
        },
        paperNodes: [],
        userInfo: {},
      },
      userInfo: {},
      unfinishedNum: 0,
      startTime: "",
      cutdownTime: Infinity, //答卷倒计时时长
      selectType: ["A", "B", "C", "D", "E", "F", "G", "H"],
      sortList: ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十"],
      isStop: false,
      canSeeGrade: true,
      isAllowSeeAnswer: true,
      imgUrl: "",
      previewVisible: false,
    };
  },
  methods: {
    moment,
    closePaper() {
      window.opener = null;
      window.open("", "_self");
      window.close();
      // this.$router.push('/exam/list');
    },
    requestDetail() {
      if (this.$route.query.examGradeUid && this.$route.query.examUid) {
        this.examUid = this.$route.query.examUid;
        this.examGradeUid = this.$route.query.examGradeUid;
      }
      Api.getPaperAnaswer(this.examUid, this.examGradeUid).then((res) => {
        this.canSeeGrade = res.data.viewResult.canSeeGrade;
        this.isAllowSeeAnswer = res.data.viewResult.isAllowSeeAnswer;
        if (res.data.examGrade.allowExamTime) {
          console.warn(
            "res.data.examGrade.allowExamTime",
            res.data.examGrade.allowExamTime
          );
          this.examTime = (res.data.examGrade.allowExamTime / 60).toFixed(1);
        }
        res.data.paperDetail.paperNodes.forEach((item) => {
          item.questions.forEach((subItem) => {
            subItem.judgeResultCode = "error";
            if (
              res.data.examGrade.examGradeAnswer &&
              res.data.examGrade.examGradeAnswer.examAnswers.length != 0
            ) {
              res.data.examGrade.examGradeAnswer.examAnswers.forEach((ele) => {
                if (ele.questionUid == subItem.id) {
                  subItem.answerText = ele.answerText;
                  subItem.answerTime = ele.answerTime;
                  subItem.judgeScore = ele.judgeScore;
                  subItem.judgeResultCode = ele.judgeResultCode;
                  subItem.isRead = ele.isRead;
                  if (subItem.questionBaseTypeCode == "multi") {
                    if (subItem.answerText.includes("$contentsplit$")) {
                      subItem.answerText =
                        subItem.answerText.split("$contentsplit$");
                    } else {
                      subItem.answerText = [...subItem.answerText];
                    }
                    subItem.answerList = [];
                    if (subItem.standardAnswers.length > 1) {
                      let arr = subItem.standardAnswers;
                      for (let i = 0; i < subItem.answerText.length; i++) {
                        let obj = {
                          value: subItem.answerText[i],
                          code: "error",
                        };
                        for (let j = 0; j < arr.length; j++) {
                          if (subItem.answerText[i] == arr[j]) {
                            obj.code = "right";
                          }
                        }
                        subItem.answerList.push(obj);
                      }
                    } else {
                      let arr = subItem.standardAnswers;
                      for (let i = 0; i < arr.length; i++) {
                        let obj = {
                          value: subItem.answerText[i],
                          code: "error",
                        };
                        for (let j = 0; j < subItem.answerText.length; j++) {
                          if (subItem.answerText[j] == arr[i]) {
                            obj.code = "right";
                          }
                        }
                        subItem.answerList.push(obj);
                      }
                    }
                  }
                  if (subItem.questionBaseTypeCode == "fill") {
                    subItem.answerList = [];

                    if (subItem.answerText.includes("$contentsplit$")) {
                      let arr = subItem.standardAnswers;
                      subItem.answerText =
                        subItem.answerText.split("$contentsplit$");
                      for (let i = 0; i < subItem.answerText.length; i++) {
                        let obj = {
                          value: subItem.answerText[i],
                          code: "error",
                        };
                        for (let j = 0; j < arr.length; j++) {
                          if (arr[j].includes("&")) {
                            arr[j].split("&").forEach((element) => {
                              if (
                                element.replace(/(^\s*)|(\s*$)/g, "") ==
                                subItem.answerText[i].replace(
                                  /(^\s*)|(\s*$)/g,
                                  ""
                                )
                              ) {
                                obj.code = "right";
                              }
                            });
                          } else if (
                            subItem.answerText[i].replace(
                              /(^\s*)|(\s*$)/g,
                              ""
                            ) == arr[j].replace(/(^\s*)|(\s*$)/g, "")
                          ) {
                            obj.code = "right";
                          }
                        }
                        subItem.answerList.push(obj);
                      }
                    } else {
                      subItem.answerText = [subItem.answerText];
                      let arr = subItem.standardAnswers;
                      for (let i = 0; i < arr.length; i++) {
                        let obj = {
                          value: subItem.answerText[i],
                          code: "error",
                        };
                        for (let j = 0; j < subItem.answerText.length; j++) {
                          if (
                            subItem.answerText[j].replace(
                              /(^\s*)|(\s*$)/g,
                              ""
                            ) == arr[i].replace(/(^\s*)|(\s*$)/g, "")
                          ) {
                            obj.code = "right";
                          }
                        }
                        subItem.answerList.push(obj);
                      }
                    }
                  }
                  if (subItem.questionBaseTypeCode == "judge_correct") {
                    if (subItem.answerText == "Y") {
                      subItem.judge_correctLabel = "Y";
                    } else {
                      subItem.judge_correctLabel = "N";
                    }
                  }
                }
                if (subItem.questionBaseTypeCode == "compose") {
                  subItem.childQuestions.forEach((childItem) => {
                    if (ele.questionUid == childItem.id) {
                      this.checkQuestion(childItem, ele);
                    }
                  });
                }
              });
              this.$forceUpdate();
            }
          });
        });
        this.detail = res.data;
        if (this.detail.exam.examTime != 0) {
          if (!this.detail.examGrade.examTime) {
            this.cutdownTime = this.detail.exam.examTime * 1000;
          } else {
            this.cutdownTime =
              this.detail.exam.examTime * 1000 -
              this.detail.examGrade.examTime * 1000;
          }
        }
      });
    },
    imgsj() {
      console.log(1);
    },
    checkQuestion(subItem, ele) {
      subItem.answerText = ele.answerText;
      subItem.answerTime = ele.answerTime;
      subItem.judgeScore = ele.judgeScore;
      subItem.judgeResultCode = ele.judgeResultCode;
      subItem.isRead = ele.isRead;
      if (subItem.questionBaseTypeCode == "multi") {
        if (subItem.answerText.includes("$contentsplit$")) {
          subItem.answerText = subItem.answerText.split("$contentsplit$");
        } else {
          subItem.answerText = [...subItem.answerText];
        }
        subItem.answerList = [];
        if (subItem.standardAnswers.length > 1) {
          let arr = subItem.standardAnswers;
          for (let i = 0; i < subItem.answerText.length; i++) {
            let obj = {
              value: subItem.answerText[i],
              code: "error",
            };
            for (let j = 0; j < arr.length; j++) {
              if (subItem.answerText[i] == arr[j]) {
                obj.code = "right";
              }
            }
            subItem.answerList.push(obj);
          }
        } else {
          let arr = subItem.standardAnswers;
          for (let i = 0; i < arr.length; i++) {
            let obj = {
              value: subItem.answerText[i],
              code: "error",
            };
            for (let j = 0; j < subItem.answerText.length; j++) {
              if (subItem.answerText[j] == arr[i]) {
                obj.code = "right";
              }
            }
            subItem.answerList.push(obj);
          }
        }
      }
      if (subItem.questionBaseTypeCode == "fill") {
        subItem.answerList = [];

        if (subItem.answerText.includes("$contentsplit$")) {
          let arr = subItem.standardAnswers;
          subItem.answerText = subItem.answerText.split("$contentsplit$");
          for (let i = 0; i < subItem.answerText.length; i++) {
            let obj = {
              value: subItem.answerText[i],
              code: "error",
            };
            for (let j = 0; j < arr.length; j++) {
              if (
                subItem.answerText[i].replace(/(^\s*)|(\s*$)/g, "") ==
                arr[j].replace(/(^\s*)|(\s*$)/g, "")
              ) {
                obj.code = "right";
              }
            }
            subItem.answerList.push(obj);
          }
        } else {
          subItem.answerText = [subItem.answerText];
          let arr = subItem.standardAnswers;
          for (let i = 0; i < arr.length; i++) {
            let obj = {
              value: subItem.answerText[i],
              code: "error",
            };
            for (let j = 0; j < subItem.answerText.length; j++) {
              if (
                subItem.answerText[j].replace(/(^\s*)|(\s*$)/g, "") ==
                arr[i].replace(/(^\s*)|(\s*$)/g, "")
              ) {
                obj.code = "right";
              }
            }
            subItem.answerList.push(obj);
          }
        }
      }
      if (subItem.questionBaseTypeCode == "judge_correct") {
        if (subItem.answerText == "Y") {
          subItem.judge_correctLabel = "Y";
        } else {
          subItem.judge_correctLabel = "N";
        }
      }
    },
    getAvatar(blobName) {
      if(!blobName){
         return;
      }
      axios
        .get(
          `${sessionStorage.getItem(
            "Link"
          )}api/app/file/download-file-system/${blobName}`,
          { responseType: "blob" }
        )
        .then(({ data }) => {
          let blob = new Blob([data]); // 返回的文件流数据
          let url = window.URL.createObjectURL(blob); // 将他转化为路径
          this.imgUrl = url; // 将转换出来的路径赋值给变量，其实和上一步结合就可以
        });
      this.$forceUpdate();
    },
    AApreviewVisible() {
      console.log(this.previewVisible, "---------------");
      this.previewVisible = true;
    },
  },
  created() {
    this.requestDetail();
    this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    this.getAvatar(this.userInfo.extraProperties.Avatar);
  },
  watch: {},
  mounted() {
    setTimeout(() => {
      let b = document.getElementsByTagName("img");
      // console.log(b);
      let arrImg = Array.from(b);
      //   console.log(arrImg);
      arrImg.forEach((i) => {
        console.log(i.currentSrc);
        if (i.currentSrc.includes("/api/app/file/download-file-byblob")) {
          i.style.maxHeight = "100px";
          i.style.maxWidth = "";
          var modal = document.getElementById("myModal");

          var modalImg = document.getElementById("img01");
          //   console.log(i);
          //        i.addEventListener("click",function(){

          //     console.log("my",i);
          // });
          i.onclick = function () {
            console.log(1, this, "-----", this.src, i.style, i);

            modal.style.display = "block";
            modalImg.src = this.src;
          };
          var span = document.getElementsByClassName("close")[0];
          span.onclick = function () {
            modal.style.display = "none";
          };
        }
      });
      // let a = document.getElementsByClassName('sad')
      // console.log(a);

      // let arr = Array.from(a)
      // console.log(a);
      // console.log(arr,arr[0].innerHTML);
      // for(let i = 0;i<arr.length;i++){
      //     console.log(arr[i].innerHTML);

      //     if(arr[i].innerHTML.includes('img ')){
      //         arr[i].addEventListener("click",function(){

      //             console.log("my",arr[i].innerHTML);
      //         });
      //         // arr[i].innerHTML =   arr[i].innerHTML.replace('img ','img @click="imgsj"')
      //         // this.$forceUpdate()
      //         console.log(arr[i].innerHTML);
      //     }
      // }
    }, 2000);

    //    setTimeout(() => {
    //     var modal=document.getElementById('myModal');
    //     var img=document.getElementById('myImg');
    //     var modalImg=document.getElementById('img01');

    //     img.onclick=function(){
    //         console.log(1,this.src,this.alt);
    //         modal.style.display='block';
    //         modalImg.src=this.src;

    //     };
    //     var span=document.getElementsByClassName('close')[0];
    //     span.onclick=function(){
    //         modal.style.display='none';
    //     }

    //    }, 2000);
  },
};
</script>

<style lang="scss" scope>
::v-deep .node-question-content {
  img {
   /* height: 50px !important;*/
    width: auto !important;
    object-fit: contain;
  }
}
.exam {
  // min-height: 100%;
  min-height: 1200px;
  width: 100%;
  background: url("./../../assets/exam/exam-bg.jpg");
  padding-top: 44px;
  // background-color: #fff;
  background-size: cover;
  .el-radio {
    display: flex;
    align-items: center;
  }
  ::v-deep .el-radio__label {
    display: inline-flex;
    align-items: center;
  }
  .el-checkbox {
    display: flex;
    align-items: center;
  }
  ::v-deep .el-checkbox__label {
    display: inline-flex;
    align-items: center;
  }
  .el-textarea {
    width: 70% !important;
  }
  .answer-right {
    background-color: #fff !important;
    border-color: rgba(68, 215, 182, 1) !important;
  }
  .answer-modal {
    width: 798px;
    min-height: 102px;
    background: #f8f8f8;
    border-radius: 3px;
    margin-left: 16px;
    padding: 16px 32px;
    p {
      margin: 0 !important;
      display: inline-block !important;
    }
    .modal-item {
      margin-bottom: 10px;
      flex: 1;
      display: flex;
      align-items: center;
      // margin-right: 50px;
      .green {
        color: #44d7b6 !important;
      }
      .red {
        color: #ff6c75 !important;
      }
      .item-left {
        font-size: 12px;
        // font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #9b9b9b;
        margin-right: 8px;
      }
      .item-right {
        max-width: 90%;
        font-size: 12px;
        // font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #000000;
        p {
          margin: 0 !important;
          display: inline-block !important;
          word-wrap: break-word !important;
          word-break: break-all !important;
        }
      }
    }
  }
  .disable {
    pointer-events: none;
  }
  .el-dialog__header {
    // padding: 20px 20px 10px;
    padding: 0;
  }
  .no-header-modal {
    padding: 20px 20px 10px;
  }
  .el-card__body {
    padding: 32px 46px;
  }

  .mg-rt {
    margin-right: 8px;
  }
  .el-input__inner {
    border: none !important;
  }
  .el-textarea__inner {
    border: none !important;
  }

  .exam-header {
    // position: fixed;
    position: relative;
    // z-index: 99;
    // top: 0;
    // height: 90px;
    // width: 100%;
    // background-color: #d7d7d7;
    margin: 0 auto;
    margin-bottom: 24px;
    width: 1300px;
    height: 300px;
    .header-detail {
      width: 100%;
      height: 256px;
      position: relative;
      .header-bg {
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        object-fit: fill;
      }
      .paper-headr {
        left: 70px;
        top: 45px;
        position: relative;
        .exam-center {
          font-size: 14px;
          font-weight: 500;
          text-align: left;
          color: #ffffff;
          line-height: 22px;
          margin-bottom: 15px;
        }
        .paper-name {
          font-size: 32px;
          font-weight: 600;
          text-align: left;
          color: #ffffff;
          line-height: 36px;
          margin-bottom: 30px;
        }
        .paper-message {
          min-width: 263px;
          max-width: 350px;
          height: 24px;
          font-size: 12px;
          background: #f5f5f5;
          border-radius: 12px;
          display: flex;
          align-items: center;
          padding-left: 18px;
          .label {
            font-weight: 400;
            text-align: left;
            color: #999999;
            line-height: 17px;
          }
        }
      }
    }
    .headers-nav {
      position: absolute;
      bottom: 0;
      height: 94px;
      width: 100%;
      background: linear-gradient(
        136deg,
        rgba(255, 255, 255, 0.82),
        rgba(255, 255, 255, 0.8) 100%
      );
      border-radius: 15px;
      box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.02);
      backdrop-filter: blur(8px);
      display: flex;
      padding-left: 65px;
      align-items: center;
      justify-content: space-between;
      .user-detail {
        display: flex;
        align-items: center;
        .user-right {
          margin-left: 28px;
          .user-name {
            font-size: 18px;
            font-weight: 600;
            text-align: left;
            color: #1e2046;
            line-height: 25px;
            margin-bottom: 8px;
          }
          .user-code {
            font-size: 14px;
            font-weight: 400;
            text-align: left;
            color: #666666;
            line-height: 20px;
          }
        }
        img {
          height: 65px;
          width: 65px;
          border-radius: 50%;
        }
      }
      .nav-right {
        align-items: center;
        display: flex;
        padding-right: 32px;
        .font-select {
          width: 260px;
          height: 30px;
        }
        .operate-btn {
          align-items: center;
          display: flex;
          .exam-btn {
            align-items: center;
            display: flex;
          }
        }
      }
    }
  }
  .exam-main {
    position: relative;
    margin: 0 auto;
    width: 1300px;
    .example-item {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      .item-content {
        border: 1px solid #e5e5e5;
        margin: 6px 0;
        padding: 3px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 16px;
        height: 16px;
      }
      .corner {
        position: absolute;
        right: -5px;
        width: 0;
        height: 0;
        top: 1px;
        border: 5px solid #e5e5e5;
        border-bottom-color: transparent;
        border-top-color: transparent;
        border-left-color: transparent;
        transform: rotateZ(135deg);
      }
      &.finish {
        .corner {
          position: absolute;
          right: -5px;
          width: 0;
          height: 0;
          top: 1px;
          border: 5px solid #1890ff;
          border-bottom-color: transparent;
          border-top-color: transparent;
          border-left-color: transparent;
          transform: rotateZ(135deg);
        }
        .item-content {
          border: 1px solid #1890ff;
          color: #fff;
          .item-centre {
            background-color: #1890ff;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    // margin-top: 40px;
    // height: 1000px;
    .main-left {
      width: 890px;
      height: 100%;
      background: linear-gradient(
        136deg,
        rgba(255, 255, 255, 0.82),
        rgba(255, 255, 255, 0.8) 100%
      );
      border-radius: 15px;
      box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.04);
      backdrop-filter: blur(8px);
      overflow: hidden;
      padding: 32px 46px;

      .sign-tips {
        font-size: 14px;
        font-weight: 400;
        text-align: left;
        color: #999999;
        line-height: 25px;
        display: flex;
        align-items: center;
      }
    }
    .main-right {
      width: 386px;
      position: absolute;
      right: 0;
      .time-remaining {
        height: 77px;
        justify-content: space-between;
        display: flex;
        background-color: #f2f2f2;
        border-radius: 15px;
        align-items: center;
        padding: 0 16px;
        margin-bottom: 32px;
        background: linear-gradient(
          136deg,
          rgba(255, 255, 255, 0.82),
          rgba(255, 255, 255, 0.8) 100%
        );
        border-radius: 15px;
        box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.02);
        backdrop-filter: blur(8px);
        font-size: 16px;
        font-weight: 400;
        text-align: left;
        color: #000000;
        .block {
          font-size: 30px;
          font-weight: 500;
          text-align: left;
          color: #1fa3ff;
          line-height: 42px;
        }
      }
      .answers-card {
        border-radius: 15px;
        width: 386px;
        overflow: hidden;
        background: linear-gradient(
          136deg,
          rgba(255, 255, 255, 0.82),
          rgba(255, 255, 255, 0.8) 100%
        );
        border-radius: 15px;
        box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.02);
        backdrop-filter: blur(8px);
        padding-bottom: 8px;
        font-size: 12px;
        font-weight: 500;
        color: #9b9b9b;
        line-height: 17px;

        .card-head {
          display: flex;
          align-items: center;
          padding: 0 24px;
          height: 52px;
          background: #102345;
          border-radius: 15px 15px 0px 0px;
          font-size: 20px;
          font-weight: 600;
          text-align: left;
          color: #ffffff;
          line-height: 25px;
        }
        .card-main {
          padding: 18px 24px;
          .card-item {
            display: flex;
            margin-bottom: 26px;
            align-items: center;
            .item-left {
              font-size: 14px;
              // font-family: PingFangSC, PingFangSC-Medium;
              font-weight: 500;
              text-align: left;
              color: #000000;
              line-height: 20px;
              margin-right: 8px;
            }
            .item-right {
              font-size: 14px;
              // font-family: PingFangSC, PingFangSC-Semibold;
              font-weight: 600;
              text-align: right;
              color: #9b9b9b;
              line-height: 20px;
            }
          }
        }
        .noAnswer {
          width: 6px;
          height: 6px;
          border: 1px solid #9b9b9b;
          border-radius: 4px;
        }
        .isAnswer {
          width: 6px;
          height: 6px;
          background: #1fa3ff;
          border-radius: 4px;
        }
        .card-title {
          height: 42px;
          border-bottom: 1px solid #e1e1e1;
        }
        .question-modal {
          padding: 8px 0;
          width: 100%;
          .modal-title {
            display: flex;
            margin-bottom: 12px;
            align-items: center;
            width: 100%;
            height: 30px;
            padding: 0 18px;
            font-size: 16px;
            font-weight: 700;
            text-align: left;
            color: #000000;
            line-height: 20px;
          }
          .tips {
            margin-left: 10px;
            font-size: 12px;
            font-weight: 400;
            text-align: right;
            color: #9b9b9b;
            line-height: 17px;
          }
          .modal-content {
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            padding: 0 13px;
            .question-item {
              color: #000;
              display: flex;
              align-items: center;
              justify-content: center;
              width: 10%;
              // max-width: 38px;
              min-width: 36px;
              position: relative;
              .corner {
                position: absolute;
                right: -5px;
                width: 0px;
                height: 0px;
                top: -5px;
                border: 4px solid #797979;
                border-bottom-color: transparent;
                border-top-color: transparent;
                border-left-color: transparent;
                transform: rotateZ(135deg);
              }
              .item-content {
                position: relative;
                border: 1px solid #e5e5e5;
                margin: 6px 0;
                padding: 3px;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 24px;
                height: 24px;
                box-sizing: border-box;
                .item-centre {
                  width: 18px;
                  height: 18px;
                  font-size: 12px;
                  font-weight: 400;
                  text-align: center;
                  color: #4a4a4a;
                  line-height: 17px;
                }
              }
              &.finish {
                .corner {
                  position: absolute;
                  right: -5px;
                  width: 0px;
                  height: 0px;
                  top: -5px;
                  border: 4px solid #1fa3ff;
                  border-bottom-color: transparent;
                  border-top-color: transparent;
                  border-left-color: transparent;
                  transform: rotateZ(135deg);
                }
                .item-content {
                  position: relative;
                  border: 1px solid #e5e5e5;
                  color: #fff;
                  .item-centre {
                    color: #fff;

                    background: #1fa3ff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 100%;
                    height: 100%;
                  }
                }
              }
            }
          }
        }
      }
      .btn-submit {
        width: 387px;
        height: 50px;
        background: rgba(68, 215, 182, 1);
        border-radius: 26px;
        margin-top: 26px;
        font-size: 16px;
        text-align: left;
        color: #ffffff;
        line-height: 34px;
        display: flex;
        align-items: center;
        justify-content: center;
        // font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
      }
    }
    .paper-detail {
      .node-head {
        font-size: 22px;
        font-weight: 600;
        text-align: left;
        color: #2d3748;
        line-height: 25px;
        .tips {
          font-size: 14px;
          font-weight: 400;
          text-align: left;
          color: #999999;
          line-height: 25px;
        }
        // margin-top: 16px;
      }
      .node-content {
        margin-top: 16px;
        .node-question {
          margin-bottom: 12px;
          // box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
          padding: 16px 0 0 0;
          p {
            margin: 0 !important;
          }
          .exam-input {
            width: 100px;
            min-width: 100px;
            border: none;
            outline: none;
            border-bottom: 1px solid #000;
          }
          .node-question-title {
            // display: flex;
            // align-items: center;
            // flex-wrap: wrap;
            font-size: 14px;
            margin-bottom: 16px;
            // font-family: PingFangSC, PingFangSC-Medium;
            font-weight: 500;
            text-align: left;
            color: #333333;
            line-height: 20px;
            padding-left: 16px;
            font-weight: 600;
            p {
              font-size: 14px;
              // font-family: PingFangSC, PingFangSC-Medium;
              font-weight: 500;
              text-align: left;
              color: #333333;
              line-height: 20px;
            }
            .tips {
              font-size: 14px;
              // font-family: PingFangSC, PingFangSC-Regular;
              font-weight: 400;
              text-align: left;
              color: #999999;
              line-height: 25px;
              margin-left: 8px;
            }
            // border-bottom: 1px solid #d7d7d7;
            .node-qusetion-typeName {
              padding: 3px 8px;
              min-width: 40px;
              height: 22px;
              background: #f5f5f5;
              border-radius: 3px;
              font-size: 12px;
              font-weight: 400;
              color: #333333;
              margin-left: 16px;
              margin-right: 10px;
              line-height: 17px;
              &.select {
                color: #fff !important;
                background-color: #1890ff !important;
                border-color: #1890ff !important;
              }
            }
          }
          .node-question-content {
            // border-bottom: 1px solid #d7d7d7;
            display: flex;
            padding: 4px 0 4px 16px;
            align-items: center;
            min-height: 34px;
            img {
              height: 50px !important;
              width: auto !important;
              object-fit: contain;
            }
            // p {
            //     margin: 0 !important;
            // }
          }
          .node-question-answers {
            padding: 4px 0 4px 16px;
            align-items: center;
            font-size: 16px;
            font-weight: 600;
            margin-bottom: 16px;
          }
        }
        #myImg {
          -webkit-border-radius: 5px;
          -moz-border-radius: 5px;
          border-radius: 5px;

          cursor: pointer;

          -webkit-transition: all 0.3s;
          -moz-transition: all 0.3s;
          -o-transition: all 0.3s;
          transition: all 0.3s;
        }
        #myImg:hover {
          opacity: 0.7;
        }

        .modal {
          display: none;
          position: fixed;
          z-index: 1;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          padding-top: 50px;
          overflow: auto;
          background-color: rgb(0, 0, 0);
          background-color: rgba(0, 0, 0, 0.85);
        }
        .modal-content {
          margin: auto;
          display: block;
          width: 100%;
          max-width: 700px;
          margin-top: 38%;
        }
        #caption {
          margin: auto;
          display: block;
          width: 80%;
          max-width: 700px;
          text-align: center;
          color: #ccc;
          padding: 10px 0;
          height: 150px;
        }
        .modal-content,
        #caption {
          -webkit-animation: zoom 0.6s;
          -o-animation: zoom 0.6s;
          animation: zoom 0.6s;
        }
        @-webkit-keyframes zoom {
          from {
            -webkit-transform: scale(0.1);
          }
          to {
            -webkit-transform: scale(1);
          }
        }
        @keyframes zoom {
          from {
            transform: scale(0.1);
          }
          to {
            transform: scale(1);
          }
        }

        .close {
          position: absolute;
          top: 15px;
          right: 35px;
          color: #f1f1f1;
          font-size: 40px;
          font-weight: bold;
          transition: 0.3s;
        }
        .close:hover,
        .close:focus {
          color: #bbb;
          text-decoration: none;
          cursor: pointer;
        }
        /* 100% Image Width on Smaller Screens */
        @media only screen and (max-width: 700px) {
          .modal-content {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                